import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

class Note extends React.Component{
	constructor(props){
		super(props);
		this.state={
			id:this.props.id,
		}
	}

	render(){
		return(
			<div className="note">
				<div className="drag drag-yellow"></div>
				<textarea></textarea>
			</div>
		);
	}
}

class TodoList extends React.Component{
	constructor(props){
		super(props);
		this.state={
			id:this.props.id,
			items:[],
			addText:''
		}
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	handleSubmit(e){
		e.preventDefault();
	    if (!this.state.addText.length) {
	      return;
	    }
		let newItem = {
			id:Date.now(),
			text:this.state.addText,
		}
		this.setState((prevState) =>({
			items:prevState.items.concat(newItem),
			addText:''
		}));
	}

	handleChange(e){
		this.setState({addText:e.target.value});
	}

	handleDelete(id){
		let arr = this.state.items;
		arr = arr.filter((item) => item.id !== id);
		this.setState({items:arr});
	}

	render(){
		return(
			<div className="to-do-list">
				<div className="drag drag-red">
					<input type="text" className="add-title" placeholder="Title"/>
				</div>
				<div className="to-do-content">
					<ul>
						{
							this.state.items.map((item) => 
								<li className="flex"  key={item.id}>
									<span>{item.text}</span>
									<button className="submit-btn hide ml-5px" onClick={(e) =>this.handleDelete(item.id)}><i className="material-icons icon-small">delete</i></button>
								</li>
							)
						}
								
					</ul>
					<form className="flex" onSubmit={this.handleSubmit}>
						<input type="text" className="add-to-do-item" onChange={this.handleChange} placeholder="add..." maxLength="14" value={this.state.addText} />
						<button className="submit-btn ml-5px"><i className="material-icons icon-small">create</i></button>
					</form>
				</div>
			</div>
		);
	}
}

class App extends React.Component{
	constructor(props){
		super(props);
		this.state={
			items:[],
		}
		this.addNote = this.addNote.bind(this);
		this.addTodoList = this.addTodoList.bind(this);
	}

	addNote(e){
		e.preventDefault();
	    const newItem = {
	    	id: Date.now(),
	    	type:'note'
	    };
	    this.setState({items: this.state.items.concat(newItem)})

	}

	addTodoList(e){
		e.preventDefault();
	    const newItem = {
	    	id: Date.now(),
	    	type:'todoList'
	    };
	    this.setState({items: this.state.items.concat(newItem)})
	}
	
	deleteComponent(id){
		let arr = this.state.items;
		arr=arr.filter((item) => item.id !== id );
		this.setState({items:arr});
	}

	render(){
		return(
			<div>
				<h1 className="title">Notice Board</h1>
				<div className="flex">
					<button type="button" className="btn" onClick={this.addNote}>Add Note</button>
					<button type="button" className="btn" onClick={this.addTodoList}>Add To-do List</button>
				</div>
				<div className="flex wrap">
					
					{	
						this.state.items
						.map((item) => item.type==='note' ? 
						
							<div className="show-area" key={item.id}>
								<Note id={item.id}/> 
								<i className="material-icons delete-btn"  onClick={(e) => this.deleteComponent(item.id)} > clear </i>		
							</div>
							:
							<div className="show-area" key={item.id}>
								<TodoList key={item.id}/>
								<i className="material-icons delete-btn"  onClick={(e) => this.deleteComponent(item.id)} > clear </i>
							</div>
								
						)
					}
					
				</div>
			</div>
		);
	}
}


ReactDOM.render(<App />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js